/**
 * Bounded Context: Presence — composable tipado
 *
 * Wrapper sobre o Pinia store para uso em componentes.
 * Usa `storeToRefs` para refs reativas em templates.
 */

import { storeToRefs } from "pinia";
import { usePresenceStore } from "../store";
import type { Presence, PresenceSignal, PresenceState } from "../types";

export function usePresence() {
  const store = usePresenceStore();
  const refs = storeToRefs(store);
  return {
    /** Refs reativas (auto-unwrapped no template). */
    state: refs.state,
    updatedAt: refs.updatedAt,
    lastSignal: refs.lastSignal,
    /** Ações (não mutar refs). */
    applySignal: (signal: PresenceSignal, next: PresenceState): void =>
      store.applySignal(signal, next),
    snapshot: (): Presence => store.view(),
  };
}
